import ListPayrollConcepts from './views/List.vue'
import CreateEditPayrollConcept from './views/CreateEdit.vue'
import GetPayrollConcept from './views/Get.vue'

export const PayrollConceptRoutes = [
  {
    path: '/payroll-concepts',
    name: 'ListPayrollConcepts',
    component: ListPayrollConcepts,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'concept:list'
    }
  },
  {
    path: '/payroll-concept',
    name: 'CreatePayrollConcept',
    component: CreateEditPayrollConcept,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'concept:create'
    }
  },
  {
    path: '/payroll-concept/:id',
    name: 'UpdatePayrollConcept',
    component: CreateEditPayrollConcept,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'concept:update'
    }
  },
  {
    path: '/payroll-concept/view/:id',
    name: 'GetPayrollConcept',
    component: GetPayrollConcept,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'concept:get'
    }
  }
]
